import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InfoCorporativaComponent } from '../../components/legal/info-corporativa/info-corporativa.component';

@Component({
  selector: 'app-directorio-administracion',
  standalone: true,
  imports: [CommonModule, InfoCorporativaComponent],
  templateUrl: './directorio-administracion.html',
  styleUrls: ['./directorio-administracion.scss']
})
export class DirectorioAdministracionComponent {
}
